var cov_h1ltdh6te = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Breadcrumb/styles/index.ts",
      hash = "c4afdcdeff3ed66e25d7bdaaf62487d209665cb4",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Breadcrumb/styles/index.ts",
    statementMap: {
      "0": {
        start: {
          line: 5,
          column: 31
        },
        end: {
          line: 5,
          column: 71
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();


var breadcrumbLess = {};
import genaration from '../../utils/classname';
export var breadcrumbClass = (cov_h1ltdh6te.s[0]++, genaration(breadcrumbLess, 'breadcrumb'));